export default class DeleteBoatPriceRequest {
    
    public boatPriceId: string | null = null;
    
}